import React from 'react';
import {Translation} from "react-i18next";
import i18next from "i18next";
import GeneralModal from "../GeneralModal/GeneralModal";
import DynamicList from "../../Lists/DynamicList/DynamicList";
import LabeledSwitch from "../../Custom UI/LabeledInputs/LabeledSwitch/LabeledSwitch";
import {roleForCompany} from "../../Helpers/CompanyHelpers";
import {fullDateTimeFormat} from "../../Helpers/DateHelpers";

export default class DataQueryCommentsModal extends React.Component {
  
  // Init
  
  constructor(props){
    super(props);
    this.state = {
      includeDeleted:['admin', 'admin_level_3', 'admin_level_4'].includes(roleForCompany(props.company)),
      shouldReload:false
    };
  }
  
  // Methods
  
  // Render

  includeDeletedChanged(aIncludeDeleted){
    this.setState({includeDeleted:aIncludeDeleted, shouldReload:true});
  }
  
  render(){
    const {isOpen, dataQuery, company, handleCloseModal, clickOutsideToClose, getDataQueryNoteComments, presentedInsideParentModal} = this.props;
    const {includeDeleted, shouldReload} = this.state;
    const canIncludeDeleted = ['admin', 'admin_level_3', 'admin_level_4'].includes(roleForCompany(company));
    const canViewDeletedAt = ['admin', 'admin_level_3', 'admin_level_4'].includes(roleForCompany(company));
    
    let columnsArray = [];
    columnsArray.push({key:'user_name', columnWeight:1, columnNameKey:'PROVIDER', propertiesArray:['user_name']});
    columnsArray.push({key:'comment_text', columnWeight:1, columnNameKey:'TEXT', propertiesArray:['comment_text']});
    columnsArray.push({key:'created_at', columnWeight:1, columnNameKey:'CREATED_AT', propertiesArray:['created_at'], dateFormat:fullDateTimeFormat});
    if(canViewDeletedAt){
      columnsArray.push({key:'deleted_at', columnWeight:1, columnNameKey:'DELETED_ON', propertiesArray:['deleted_at'], dateFormat:fullDateTimeFormat});
    }
  
    return (
      <GeneralModal title={<Translation>{(t, { i18n }) => t('VIEW_DATA_QUERY_COMMENTS')}</Translation>}
                    isOpen={isOpen}
                    width={canViewDeletedAt ? 800 : 700}
                    handleSave={() => this.handleGroupCodesHistoryDownload()}
                    noTitleHeading={true}
                    handleCloseModal={handleCloseModal}
                    clickOutsideToClose={clickOutsideToClose}
                    presentedInsideParentModal={presentedInsideParentModal}
                    contentZIndex={presentedInsideParentModal ? 9000011 : null}>
        <DynamicList id="data-query-comments-modal"
                     didReload={() => this.setState({shouldReload:false})}
                     menuCancel={() => this.setState({selectedDataQuery:null})}
                     columnsArray={columnsArray}
                     fetchObjects={(aLimit, aOffset, aSearchString) => getDataQueryNoteComments(dataQuery && dataQuery.id, aLimit, aOffset, aSearchString, canIncludeDeleted && includeDeleted)}
                     shouldReload={shouldReload}
                     headerView={canIncludeDeleted ?
                       <LabeledSwitch className="data-queries-list-include-deleted"
                                      label={i18next.t('INCLUDE_DELETED')}
                                      checked={includeDeleted}
                                      onChange={(aChecked) => this.includeDeletedChanged(aChecked)}
                                      showCheckedLabels={false}
                                      switchPosition={'right'}
                       />
                       : null}
                     responseTotalKeysArray={['data', 'data', 'data_query_comments_page', 'total']}
                     responseObjectKeysArray={['data', 'data', 'data_query_comments_page', 'data_query_comments']}
        />
      </GeneralModal>
    );
  }
}
